<template>
  <crm-side-panel @handleClose="handleCloseDetail" :title="compactDetail.contractNo">
    <div class="side-panel-content compact-detail-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="contractAuth.updateContract && contractAuth.updateContract.toggleStatus"
          :size="'mini'"
          :text="'编辑'"
          @click="handleUpdate()"
        >
        </crm-button>
        <crm-button
          v-if="contractAuth.deleteContract && contractAuth.deleteContract.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 合同信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">客户名称</p>
            <p class="info-detail">{{ compactDetail.customerName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">合同金额(元)</p>
            <p class="info-detail">{{ compactDetail.contractAmount }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">回款金额(元)</p>
            <p class="info-detail">{{ compactDetail.refundAmount }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">{{ compactDetail.userName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员所属部门</p>
            <p class="info-detail">{{ compactDetail.teamName }}</p>
          </div>
        </div>
      </div>
      <!-- 合同详情各tab项 -->
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" @tab-click="handleClick" :stretch="false">
          <!-- 合同信息tab页 -->
          <el-tab-pane label="合同信息" name="compactInfo" v-loading="loading">
            <pane-info
              :contractModule="contractModule"
              :detail="compactDetail"
            ></pane-info>
          </el-tab-pane>
          <!-- 回款记录tab页 -->
          <el-tab-pane
            label="回款记录"
            name="returnRecord"
            v-if="contractAuth.paybackTab && contractAuth.paybackTab.toggleStatus"
          >
            <div class="return-record-info">
              <crm-button
                v-if="
                  contractAuth.exportPayBack && contractAuth.exportPayBack.toggleStatus
                "
                :buttonType="'plain'"
                :size="'mini'"
                :text="'导出'"
                :disabled="isDownload"
                class="fr mb10"
                @click="handleExportReturnRecord"
              >
              </crm-button>
              <crm-button
                v-if="contractAuth.addPayBack && contractAuth.addPayBack.toggleStatus"
                :size="'mini'"
                :text="'新增回款记录'"
                class="fr mb10"
                @click="handleAddReturnRecord"
              >
              </crm-button>
            </div>
            <el-table
              :data="returndRecord.results"
              v-loading="returnLoading"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="refundType" label="回款类型" align="center">
              </el-table-column>
              <el-table-column
                prop="refundAmountStr"
                label="回款金额(元)"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="refundInstallment"
                label="回款期数"
                align="center"
                :formatter="handleFormatterRefundInstallment"
              >
              </el-table-column>
              <el-table-column
                prop="customerName"
                label="客户"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="salesmanName" label="业务员" align="center">
              </el-table-column>
              <el-table-column
                prop="updateTimeStr"
                label="更新时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleGetDetail(scope)" type="text" size="small">
                    查看
                  </el-button>
                  <el-button
                    v-if="
                      contractAuth.updatePayBack &&
                      contractAuth.updatePayBack.toggleStatus
                    "
                    @click="handleEditPayback(scope)"
                    type="text"
                    size="small"
                    :disabled="
                      scope.row.examineStatus === '待入账' ||
                      scope.row.examineStatus === '已入账'
                    "
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="
                      contractAuth.deletePayback &&
                      contractAuth.deletePayback.toggleStatus
                    "
                    @click="handleDeleteReturnRecord(scope)"
                    type="text"
                    size="small"
                    :disabled="
                      scope.row.examineStatus === '待入账' ||
                      scope.row.examineStatus === '已入账'
                    "
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <div class="info-wrap">
                <span class="info-title">开票总金额：</span>
                <span class="info-detail">{{ compactDetail.invoiceAmount }}元</span>
                <span class="info-title">回款总金额：</span>
                <span class="info-detail">{{ compactDetail.refundAmount }}元</span>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="returnRecord.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="returnRecord.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="returndRecord.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 开票记录tab页 -->
          <el-tab-pane
            label="开票记录"
            name="billsRecord"
            v-if="
              contractAuth.contractReceivable &&
              contractAuth.contractReceivable.toggleStatus
            "
          >
            <div class="return-record-info">
              <crm-button
                v-if="
                  contractAuth.contractDownloadReceivable &&
                  contractAuth.contractDownloadReceivable.toggleStatus
                "
                :buttonType="'plain'"
                :size="'mini'"
                :text="'导出'"
                :disabled="isDownload"
                class="fr mb10"
                @click="handleExportBillsRecord"
              >
              </crm-button>
              <crm-button
                v-if="
                  contractAuth.contractAddReceivable &&
                  contractAuth.contractAddReceivable.toggleStatus
                "
                :size="'mini'"
                :text="'新增开票记录'"
                class="fr mb10"
                @click="handleAddBillsRecord"
              >
              </crm-button>
            </div>
            <el-table
              :data="billsListRecord.results"
              v-loading="billsLoading"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="invoiceAmount" label="开票金额(元)" align="center">
              </el-table-column>
              <el-table-column prop="invoiceDate" label="开票日期" align="center">
              </el-table-column>
              <el-table-column prop="invoiceNo" label="发票编号" align="center">
              </el-table-column>
              <el-table-column prop="billHead" label="发票抬头" align="center">
              </el-table-column>
              <el-table-column prop="remarks" label="备注" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleCheckBillsRecord(scope)"
                    type="text"
                    size="small"
                  >
                    查看
                  </el-button>
                  <el-button
                    v-if="
                      contractAuth.contractUpdateReceivable &&
                      contractAuth.contractUpdateReceivable.toggleStatus
                    "
                    @click="handleUpdateBillsRecord(scope)"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="
                      contractAuth.contractDeleteReceivable &&
                      contractAuth.contractDeleteReceivable.toggleStatus
                    "
                    @click="handleDeleteBillsRecord(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <div class="info-wrap">
                <span class="info-title">开票总金额：</span>
                <span class="info-detail">{{ compactDetail.invoiceAmount }}元</span>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="billsRecord.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="billsRecord.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="billsListRecord.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 成本tab页 -->
          <el-tab-pane
            label="成本"
            name="cost"
            v-if="contractAuth.costTab && contractAuth.costTab.toggleStatus"
          >
            <div class="return-record-info">
              <crm-button
                v-if="contractAuth.costExport && contractAuth.costExport.toggleStatus"
                :buttonType="'plain'"
                :size="'mini'"
                :text="'导出'"
                class="fr mb10"
                @click="handleExportCost"
              >
              </crm-button>
              <crm-button
                v-if="contractAuth.costAdd && contractAuth.costAdd.toggleStatus"
                :size="'mini'"
                :text="'新增成本'"
                class="fr mb10"
                @click="handleAddCost"
              >
              </crm-button>
            </div>
            <el-table
              :data="compactCostData.results"
              v-loading="costLoading"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="costAmount" label="成本(元)" align="center">
              </el-table-column>
              <el-table-column
                prop="costDate"
                label="产生日期"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="costTypeName" label="成本类型" align="center">
              </el-table-column>
              <el-table-column prop="payee" label="收款方" width="180" align="center">
              </el-table-column>
              <el-table-column
                prop="remarks"
                show-overflow-tooltip
                label="备注"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="createdName" label="创建人" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtCreated"
                label="创建时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="contractAuth.costUpdate && contractAuth.costUpdate.toggleStatus"
                    @click="handleUpdateCost(scope)"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="contractAuth.costDel && contractAuth.costDel.toggleStatus"
                    @click="handleDeleteCost(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <div class="info-wrap">
                <span class="info-title">总成本：</span>
                <span class="info-detail">{{ compactDetail.costAmount }}元</span>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="cost.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="cost.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="compactCostData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 费用tab页 -->
          <el-tab-pane
            label="费用"
            name="pay"
            v-if="contractAuth.contractFee && contractAuth.contractFee.toggleStatus"
          >
            <div class="return-record-info">
              <crm-button
                v-if="
                  contractAuth.contractFeeAdd && contractAuth.contractFeeAdd.toggleStatus
                "
                :size="'mini'"
                :text="'新增费用'"
                class="fr mb10"
                @click="handleAddPay"
              >
              </crm-button>
            </div>
            <el-table
              :data="payDataList.results"
              v-loading="addPayDialog.payLoading"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="fee" label="费用(元)" align="center">
              </el-table-column>
              <el-table-column prop="feeDate" label="产生日期" width="100" align="center">
              </el-table-column>
              <el-table-column prop="feeTypeName" label="费用类型" align="center">
              </el-table-column>
              <el-table-column prop="payee" label="收款方" width="180" align="center">
              </el-table-column>
              <el-table-column
                prop="remarks"
                show-overflow-tooltip
                label="备注"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="creator" label="创建人" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtCreated"
                label="创建时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      contractAuth.contractFeeUpdate &&
                      contractAuth.contractFeeUpdate.toggleStatus
                    "
                    @click="handleUpdatePay(scope)"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="
                      contractAuth.contractFeeDelete &&
                      contractAuth.contractFeeDelete.toggleStatus
                    "
                    @click="handleDeletePay(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <div class="info-wrap">
                <span class="info-title">总费用：</span>
                <span class="info-detail">{{ compactDetail.feeAmount }}元</span>
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pay.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="pay.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="payDataList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 附件tab页 -->
          <el-tab-pane
            label="附件"
            name="fileData"
            v-if="
              contractAuth.contractFileTab && contractAuth.contractFileTab.toggleStatus
            "
          >
            <el-upload
              class="mb10 text-right"
              action="string"
              :before-upload="handleBeforeUpload"
              :show-file-list="false"
              :http-request="handleUploadFile"
            >
              <crm-button
                v-if="
                  contractAuth.contractUploadFile &&
                  contractAuth.contractUploadFile.toggleStatus
                "
                :buttonType="'secondary'"
                :size="'mini'"
                :text="'上传附件'"
              >
                <el-tooltip
                  content="图片文件单个不能超过5M;其他文件单个不能超过50M"
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question" style="font-size: 16px"></span>
                </el-tooltip>
              </crm-button>
            </el-upload>
            <el-table
              :data="compactFileData.results"
              v-loading="fileLoading"
              class="tab-table-item"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="creatorName" label="操作人" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="上传时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="fileUrl"
                label="附件"
                align="center"
              >
                <template slot-scope="scope">
                  <a
                    v-if="
                      contractAuth.contractFilePreview &&
                      contractAuth.contractFilePreview.toggleStatus &&
                      scope.row.previewUrl
                    "
                    href="javascript:;"
                    @click="getFildUrl(scope.row)"
                  >
                    {{ scope.row.fileName }}
                  </a>
                  <span v-else>{{ scope.row.fileName || "暂无数据" }}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      contractAuth.contractDeleteFile &&
                      contractAuth.contractDeleteFile.toggleStatus
                    "
                    @click="handleDeleteFile(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                  <a
                    v-if="
                      contractAuth.contractFileDownload &&
                      contractAuth.contractFileDownload.toggleStatus &&
                      scope.row.fileUrl
                    "
                    :href="scope.row.fileUrl"
                  >
                    下载
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="fileData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="fileData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="compactFileData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 编辑合同弹窗 -->
    <update-compact
      v-if="updateCompactDialogVisible"
      :id="detailId"
      :contractType="contractType"
      @close="updateCompactDialogVisible = false"
      @success="handleRefreshCompact()"
    >
    </update-compact>

    <!-- 编辑合同弹窗 -->
    <update-compact
      v-if="updateCompactDialogVisible"
      :id="detailId"
      :contractType="contractType"
      @close="updateCompactDialogVisible = false"
      @success="handleRefreshCompact()"
    >
    </update-compact>

    <!-- 新增、编辑、查看回款明细弹窗 -->
    <payback-dialog
      ref="paybackRef"
      :row="row"
      @handle-success-payback="handleGetReturnRecord"
    />

    <!-- 新增、编辑、查看发票明细弹窗 -->
    <dialog-bills-detail
      ref="dialogBills"
      :detailId="detailId"
      @getCompactDetail="getCompactDetail"
      @handleGetBillsRecord="handleGetBillsRecord"
    ></dialog-bills-detail>

    <!-- 新增成本弹窗 -->
    <el-dialog
      title="新增成本"
      :visible.sync="addCostDialogVisible"
      width="50%"
      append-to-body
    >
      <add-cost
        v-if="addCostDialogVisible"
        :compactId="detailId"
        @close="addCostDialogVisible = false"
        @success="handleRefreshCost()"
      >
      </add-cost>
    </el-dialog>

    <!-- 编辑成本弹窗 -->
    <el-dialog
      title="编辑成本"
      :visible.sync="updateCostDialogVisible"
      width="50%"
      append-to-body
    >
      <update-cost
        v-if="updateCostDialogVisible"
        :costDetail="costDetail"
        @close="updateCostDialogVisible = false"
        @success="handleRefreshCost()"
      >
      </update-cost>
    </el-dialog>
    <!-- 回款详情 -->
    <payback-detail ref="paybackDetailRef" />

    <!-- 费用弹窗 -->
    <el-dialog
      @title="addPayDialog.type === 'eidt' ? '编辑费用' : '新增费用'"
      :visible.sync="addPayDialog.visible"
      width="50%"
      append-to-body
    >
      <add-pay
        v-if="addPayDialog.visible"
        :type="addPayDialog.type"
        :compactId="detailId"
        :payDetail="addPayDialog.payDetail"
        @close="addPayDialog.visible = false"
        @success="handleRefreshPay()"
      >
      </add-pay>
    </el-dialog>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow, newDownloadByUrl } from "@/scripts/utils";
import { uploadFileVerify } from "@/scripts/reg";

import UpdateCompact from "~component/business/compact/UpdateCompact.vue";
import AddCost from "~component/business/compact/AddCost.vue";
import AddPay from "~component/business/compact/AddPay.vue";
import UpdateCost from "~component/business/compact/UpdateCost.vue";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "@/components/base/crmButton";
import PaneInfo from "./pane-info.vue";
import paybackDialog from "./paybackDialog.vue";
import paybackDetail from "./payback-detail";
import DialogBillsDetail from "./components/dialogBillsDetail.vue";

export default {
  components: {
    UpdateCompact,
    AddCost,
    UpdateCost,
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    AddPay,
    paybackDialog,
    paybackDetail,
    DialogBillsDetail,
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {
    formatTimeShow,
  },
  props: {
    contractNumber: String,
    contractAmount: String,
    detailId: String,
    detailTabName: String,
    row: Object,
  },
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error("请输入最多两位小数且无逗号的数字"));
      } else if (value > 999999999.99) {
        callback(new Error("最大999999999.99"));
      } else {
        callback();
      }
    };
    return {
      imagePreview: {
        showImage: false,
        url: "",
      },
      isDownload: false,
      loading: false,
      contractModule: null,
      moneyRule: {
        validator: validateMoney,
        trigger: "blur",
      },
      // 编辑
      updateCompactDialogVisible: false,
      contractType: "",
      detail: {},
      isRefresh: false,
      busiOpportunityDetail: {},
      busiVisitData: [],
      busiFileData: [],
      activeTab: "compactInfo",
      returnLoading: false,
      returnRecord: {
        pageNumber: 1,
        pageSize: 5,
      },
      billsLoading: false,
      billsRecord: {
        pageNumber: 1,
        pageSize: 5,
      },
      costLoading: false,
      cost: {
        pageNumber: 1,
        pageSize: 5,
      },
      fileLoading: false,
      fileData: {
        pageNumber: 1,
        pageSize: 5,
      },
      addCostDialogVisible: false,
      updateCostDialogVisible: false,
      costDetail: {},
      returnOpenFrom: "",
      // 新增编辑开票记录
      isAddBillsDisabled: false,
      addUpdateBillsVisible: false,
      billsOpenFrom: "",
      billsTitle: "",
      billsId: "",
      addUpdateBillsForm: {
        invoiceAmountStr: "",
        invoiceDate: "",
        invoiceNo: "",
        remarks: "",
        detailed: [],
      },
      delBillsDetailed: [],
      // 新增编辑费用
      addPayDialog: {
        visible: false,
        type: "add",
        payLoading: false,
        payDetail: {},
      },
      pay: {
        pageNumber: 1,
        pageSize: 5,
      },
    };
  },
  computed: {
    ...mapGetters({
      crmAuth: "common/crmAuth",
      auth: "authority/auth",
      compactDetail: "compact/compactDetail",
      // 回款记录
      returndRecord: "compact/returndRecord",
      returndRecordDetail: "compact/returndRecordDetail",
      // 发票记录
      billsListRecord: "compact/billsRecord",
      billsRecordDetail: "compact/billsRecordDetail",

      compactFileData: "compact/compactFileData",
      compactCostData: "compact/compactCostData",
      payDataList: "compact/payDataList",
      contractAuth: "authority/contractAuth",
    }),
    ReturndTotalMoney() {
      let total = null;
      if (this.addUpdateReturnForm.detailed) {
        this.addUpdateReturnForm.detailed.forEach((item) => {
          if (item.refundAmountStr) {
            total += item.refundAmountStr * 100;
          }
        });
      }
      return total / 100;
    },
    BillsTotalMoney() {
      let total = null;
      if (this.addUpdateBillsForm.detailed) {
        this.addUpdateBillsForm.detailed.forEach((item) => {
          if (item.refundAmountStr) {
            total += item.refundAmountStr * 100;
          }
        });
      }
      return total / 100;
    },
  },
  watch: {
    detailId(val) {
      this.loading = true;
      this.getAuthority({ menuUrl: "/compact/contract" });
      this.getCompactDetail({ id: val })
        .then(() => {
          if (
            this.compactDetail.contractType === "21cbef6460f249f1ba39716e60922117" ||
            this.compactDetail.contractType === "cbb006bf8d35416fb6cd28442c570f38"
          ) {
            this.contractModule = 2;
          } else if (
            this.compactDetail.contractType === "8629ff61554941f282146ce6cbba3856"
          ) {
            this.contractModule = 3;
          } else {
            this.contractModule = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.isRefresh = false;
      this.activeTab = "compactInfo";
    },
    detailTabName(val) {
      if (val) {
        this.activeTab = val;
        this.handleClick();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteCompact: "compact/deleteCompact",
      getCompactDetail: "compact/getCompactDetail",
      // 回款记录
      getReturndRecord: "compact/getReturndRecord",
      deleteReturnRecord: "compact/deleteReturnRecord",
      saveAddReturn: "compact/saveAddReturn",
      saveUpdateReturn: "compact/saveUpdateReturn",
      getReturndRecordDetail: "compact/getReturndRecordDetail",
      deletePaybackRecord: "compact/deletePaybackRecord",
      // 发票记录
      getBillsRecord: "compact/getBillsRecord",
      deleteBillsRecord: "compact/deleteBillsRecord",
      saveAddBills: "compact/saveAddBills",
      saveUpdateBills: "compact/saveUpdateBills",
      getBillsRecordDetail: "compact/getBillsRecordDetail",

      getCompactFileList: "compact/getCompactFileList",
      uploadCompactFile: "compact/uploadCompactFile",
      deleteCompactFile: "compact/deleteCompactFile",
      getCompactCostList: "compact/getCompactCostList",
      deleteCompactCost: "compact/deleteCompactCost",
      getPayDataList: "compact/getPayDataList",
      deleteCompactFee: "compact/deleteCompactFee",
      getAuthority: "authority/getAuthority",
    }),
    async handleDownloadRecord(url) {
      try {
        this.isDownload = true;
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isDownload = false;
    },
    // 导出回款记录
    async handleExportReturnRecord() {
      const url = `/api/receivableManagement/export?contractId=${this.detailId}`;
      this.handleDownloadRecord(url);
    },
    // 导出开票记录
    handleExportBillsRecord() {
      const url = `/api/crmcontract/download/receivable?contractId=${this.detailId}`;
      this.handleDownloadRecord(url);
    },
    // 导出成本
    handleExportCost() {
      const url = `/api/crmcontract/download/cost?contractId=${this.detailId}`;
      this.handleDownloadRecord(url);
    },
    handleCloseDetail() {
      this.$emit("handleCloseDetail", this.isRefresh);
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    // 编辑
    handleUpdate() {
      this.updateCompactDialogVisible = true;
      this.contractType = this.compactDetail.contractType;
    },
    closeAddUpdate(isRefresh) {
      this.addUpdateVisible = false;
      this.isRefresh = true;
      if (isRefresh) {
        this.getCompactDetail({ id: this.detailId });
      }
    },
    handleRefreshCompact() {
      this.isRefresh = true;
      this.getCompactDetail({ id: this.detailId });
    },
    // 删除商机
    handleDelete() {
      this.$confirm("是否确定删除该合同？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompact({ id: this.detailId }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
          this.isRefresh = true;
          this.handleCloseDetail();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleDeleteCompact() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompact({ id: this.detailId }).then(() => {
            this.handleCloseDetail();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
    // tab 切换
    handleClick() {
      this.returnRecord = {
        pageNumber: 1,
        pageSize: 5,
      };
      this.billsRecord = {
        pageNumber: 1,
        pageSize: 5,
      };
      this.fileData = {
        pageNumber: 1,
        pageSize: 5,
      };
      this.cost = {
        pageNumber: 1,
        pageSize: 5,
      };
      this.pay = {
        pageNumber: 1,
        pageSize: 5,
      };
      this.handleGetTabData();
    },
    handleGetTabData() {
      switch (this.activeTab) {
        case "compactInfo":
          // this.getCompactDetail({ id: this.detailId });
          break;
        case "billsRecord":
          this.handleGetBillsRecord();
          break;
        case "returnRecord":
          this.handleGetReturnRecord();
          break;
        case "fileData":
          this.handleGetFileList();
          break;
        case "cost":
          this.handleGetCostList();
          break;
        case "pay":
          this.handleGetPayList();
          break;
        default:
          break;
      }
    },
    handleGetCostList() {
      this.costLoading = true;
      const { pageSize, pageNumber } = this.cost;
      this.getCompactCostList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactCostData.results.length === 0 && pageNumber !== 1) {
          this.cost.pageNumber = 1;
          this.handleGetCostList();
        } else {
          this.costLoading = false;
        }
      });
    },
    handleGetPayList() {
      this.addPayDialog.payLoading = true;
      const { pageSize, pageNumber } = this.pay;
      this.getPayDataList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.payDataList.results.length === 0 && pageNumber !== 1) {
          this.pay.pageNumber = 1;
          this.handleGetPayList();
        } else {
          this.addPayDialog.payLoading = false;
        }
      });
    },
    handleSizeChange(val) {
      this[this.activeTab].pageSize = val;
      this[this.activeTab].pageNumber = 1;
      this.handleGetTabData();
    },
    handleCurrentChange(val) {
      this[this.activeTab].pageNumber = val;
      this.handleGetTabData();
    },
    // 回款记录
    handleFormatterRefundInstallment(row) {
      return row.refundInstallment === 0 ? "--" : row.refundInstallment;
    },
    // 打开新增回款记录窗口
    handleAddReturnRecord() {
      this.$refs.paybackRef.handleOpen();
    },
    // 查看回款详情
    handleGetDetail({ row }) {
      this.$refs.paybackDetailRef.handleOpenDetail(row.id);
    },
    // 编辑回款
    handleEditPayback({ row }) {
      this.$refs.paybackRef.handleEdit(row);
    },
    handleGetReturnRecord() {
      this.returnLoading = true;
      const { pageNumber, pageSize } = this.returnRecord;
      this.getReturndRecord({
        contractId: this.detailId,
        pageNumber,
        pageSize,
      }).finally(() => {
        if (this.returndRecord?.results?.length === 0 && pageNumber !== 1) {
          this.returnRecord.pageNumber = 1;
          this.handleGetReturnRecord();
        } else {
          this.returnLoading = false;
        }
      });
    },
    // 打开查看回款记录窗口
    handleCheckReturnRecord(scope) {
      this.getReturndRecordDetail({ id: scope.row.id }).then(() => {
        this.addUpdateReturnForm = this.returndRecordDetail;
      });
      this.returnOpenFrom = "check";
      this.addUpdateReturnVisible = true;
      this.returnTitle = "查看回款记录";
    },
    // 删除回款记录
    handleDeleteReturnRecord(scope) {
      this.$confirm("是否确定删除该记录？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deletePaybackRecord({ idList: [scope.row.id] }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.isRefresh = true;
            this.handleGetReturnRecord();
            this.getCompactDetail({ id: this.detailId });
          });
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 新增回款记录弹窗-新增回款明细
    handleAddReturndDetail() {
      this.addUpdateReturnForm.detailed.push({
        refundAmountStr: "",
        refundDate: "",
      });
    },
    // 新增回款记录弹窗-删除回款明细
    handleDeleteReturndDetail(e) {
      const index = e.target.dataset.index;
      if (this.addUpdateReturnForm.detailed[index].id) {
        this.delDetailed.push(this.addUpdateReturnForm.detailed[index].id);
      }
      this.addUpdateReturnForm.detailed.splice(index, 1);
    },
    // 发票记录
    // 打开新增开票记录窗口
    handleAddBillsRecord() {
      this.$refs.dialogBills.billsOpenFrom = "add";
      this.$refs.dialogBills.addUpdateBillsVisible = true;
      this.$refs.dialogBills.billsTitle = "新增开票记录";
      this.$refs.dialogBills.addUpdateBillsForm.detailed = [];
    },
    // 打开编辑发票记录窗口
    handleUpdateBillsRecord(scope) {
      this.$refs.dialogBills.billsId = scope.row.id;
      this.getBillsRecordDetail({ id: scope.row.id }).then(() => {
        this.$refs.dialogBills.addUpdateBillsForm = {
          invoiceAmountStr: this.billsRecordDetail.invoiceAmountStr,
          invoiceDate: this.billsRecordDetail.invoiceDate,
          invoiceNo: this.billsRecordDetail.invoiceNo,
          remarks: this.billsRecordDetail.remarks,
          detailed: this.billsRecordDetail.detailed,
          billHead: this.billsRecordDetail.billHead,
        };
      });
      this.$refs.dialogBills.billsOpenFrom = "update";
      this.$refs.dialogBills.addUpdateBillsVisible = true;
      this.$refs.dialogBills.billsTitle = "编辑开票记录";
    },
    // 新增回款-业务结算部门
    changeSettlements() {},
    // 获取发票记录
    handleGetBillsRecord() {
      this.billsLoading = true;
      const { pageNumber, pageSize } = this.billsRecord;
      this.getBillsRecord({
        contractId: this.detailId,
        pageNumber,
        pageSize,
      }).finally(() => {
        if (this.billsListRecord.results.length === 0 && pageNumber !== 1) {
          this.billsRecord.pageNumber = 1;
          this.handleGetBillsRecord();
        } else {
          this.billsLoading = false;
        }
      });
    },
    // 打开查看发票记录窗口
    handleCheckBillsRecord(scope) {
      this.getBillsRecordDetail({ id: scope.row.id }).then(() => {
        this.$refs.dialogBills.addUpdateBillsForm = this.billsRecordDetail;
      });
      this.$refs.dialogBills.billsOpenFrom = "check";
      this.$refs.dialogBills.addUpdateBillsVisible = true;
      this.$refs.dialogBills.billsTitle = "查看开票记录";
    },
    // 删除发票记录
    handleDeleteBillsRecord(scope) {
      this.$confirm("是否确定删除该记录？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBillsRecord({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.isRefresh = true;
            this.handleGetBillsRecord();
            this.getCompactDetail({ id: this.detailId });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 新增发票记录弹窗-删除发票明细
    handleDeleteBillsDetail(e) {
      const index = e.target.dataset.index;
      if (this.addUpdateBillsForm.detailed[index].id) {
        this.delBillsDetailed.push(this.addUpdateBillsForm.detailed[index].id);
      }
      this.addUpdateBillsForm.detailed.splice(index, 1);
    },
    // 新增成本
    handleAddCost() {
      this.addCostDialogVisible = true;
    },
    // 编辑成本
    handleUpdateCost(scope) {
      this.costDetail = scope.row;
      this.updateCostDialogVisible = true;
    },
    // 删除成本
    handleDeleteCost(scope) {
      this.$confirm("是否确定删除该成本？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompactCost({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleRefreshCost();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 更改了成本之后刷新数据
    handleRefreshCost() {
      this.handleGetCostList();
      this.isRefresh = true;
      this.getCompactDetail({ id: this.detailId });
    },
    // 新增费用
    handleAddPay() {
      this.addPayDialog.visible = true;
      this.addPayDialog.type = "add";
    },
    // 编辑费用
    handleUpdatePay(scope) {
      this.addPayDialog.payDetail = scope.row;
      this.addPayDialog.visible = true;
      this.addPayDialog.type = "edit";
    },
    // 删除费用
    handleDeletePay(scope) {
      this.$confirm("是否确定删除该费用？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompactFee({ id: scope.row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleRefreshPay();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 更改了费用之后刷新数据
    handleRefreshPay() {
      this.handleGetPayList();
      this.isRefresh = true;
      this.getCompactDetail({ id: this.detailId });
    },
    // 附件表格
    handleUploadFile(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      params.append("bizUid", this.detailId);
      this.uploadCompactFile({
        params,
        config: { "Content-Type": "multipart/form-data", timeout: 100000 },
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.handleGetFileList();
          this.isRefresh = true;
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    handleGetFileList() {
      this.fileLoading = true;
      const { pageSize, pageNumber } = this.fileData;
      this.getCompactFileList({
        bizUid: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactFileData.results.length === 0 && pageNumber !== 1) {
          this.fileData.pageNumber = 1;
          this.handleGetFileList();
        } else {
          this.fileLoading = false;
        }
      });
    },
    handleDeleteFile(scope) {
      this.$confirm("是否确定删除附件？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCompactFile({
            id: scope.row.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleGetFileList();
          });
          this.isRefresh = true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handleBeforeUpload(file) {
      /* eslint-disable */
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return Promise.reject();
      }

      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
  },
};
</script>

<style lang="less">
.compact-detail-content {
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.busi-dialog {
  padding: 0 30px;
  .el-form-item__label {
    float: none;
  }
}
.dialog-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.returnd-money-wrap {
  width: 100%;
  border-top: 1px dashed #cccccc;
  .returnd-money-title {
    width: 60px;
    background-color: #ffffff;
    margin-top: -12px;
  }
  .icon-delete {
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    margin-left: -130px;
    color: #f56c6c;
  }
}
.date-add-return {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}
</style>
